import styled, { css } from 'styled-components'

import { LabelSize } from './label.types'

const LABEL_FONT_SIZE_MAP: Record<LabelSize, string> = {
  large: '1.6rem',
  medium: '1.4rem',
  small: '1.2rem',
}

const LABEL_LINE_HEIGHT_MAP: Record<LabelSize, string> = {
  large: '2.4rem',
  medium: '2rem',
  small: '1.6rem',
}

export const Label = styled.label<{ $size: LabelSize; $disabled: boolean; $hasError: boolean }>(
  ({ theme, $size, $disabled, $hasError }) => {
    const baseStyles = css`
      display: flex;
      align-items: center;
      gap: ${theme.space['4']};
      color: ${theme.colors.primary800};
      font-family: inherit;
      font-size: ${LABEL_FONT_SIZE_MAP[$size]};
      line-height: ${LABEL_LINE_HEIGHT_MAP[$size]};
      font-weight: 500;
      max-width: fit-content;
      flex-shrink: 0;

      > [data-component-id='Tooltip'] svg {
        color: ${theme.colors.primary800};
      }
    `

    const disabledStyles =
      $disabled &&
      css`
        color: ${theme.colors.primary500};

        > [data-component-id='Tooltip'] svg {
          color: ${theme.colors.primary500};
        }
      `

    const errorStyles =
      $hasError &&
      css`
        color: ${theme.colors.red500};

        > [data-component-id='Tooltip'] svg {
          color: ${theme.colors.red500};
        }
      `

    return css`
      ${baseStyles}
      ${disabledStyles}
      ${errorStyles}
    `
  },
)
